module.exports = __webpack_public_path__ + "img/数据挖掘.8d9a6e30.jpg";